import * as Yup from 'yup';

const AISystemSchema = Yup.object().shape({
  file: Yup.mixed().required('File is required').nullable(false), // ensures it's not null
  templateId: Yup.string().required('TEVV Type is required'),
  description: Yup.string().optional(),
});

const SendAssessmentVendorSchema = Yup.object().shape({
  senderType: Yup.string(),
  memberId: Yup.string().when('senderType', {
    is: 'internal',
    then: (schema) => schema.required('Member is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  name: Yup.string().when('senderType', {
    is: 'external',
    then: (schema) => schema.required('Name is required'),
    otherwise: (schema) => schema.notRequired(),
  }),

  email: Yup.string().when('senderType', {
    is: 'external',
    then: (schema) =>
      schema.required('Email is required').email('Please enter valid email'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export { AISystemSchema, SendAssessmentVendorSchema };
